// import Swiper from "swiper"
import { q, qq } from "../../helper/q"
import { Swiper } from "swiper/dist/js/swiper.esm.js"

export const paymentInit = () => {
  const sliderElement = q(".stockContent")
  if (sliderElement) {
    const stockSlider = new Swiper(sliderElement, {
      slidesPerView: 1,
      autoHeight: true
    })

    const stockButtons = qq(".stockOption")
    stockButtons.forEach((stockButton, index) => {
      stockButton.addEventListener("click", () => {
        stockButtons.forEach(button => {
          button.classList.remove("stockOptionActive")
        })
        stockButton.classList.add("stockOptionActive")
        stockSlider.slideTo(index)
      })
    })
  }

  const copyButton = q(".requisitesButton")
  let copyTimer
  if (copyButton) {
    copyButton.addEventListener("click", () => {
      copyButton.classList.add("requisitesButtonActive")
      copyButton.disabled = true
      clearTimeout(copyTimer)
      copyTimer = setTimeout(() => {
        copyButton.classList.remove("requisitesButtonActive")
        copyButton.disabled = false
      }, 2000)
    })
  }
}
